import React, { useState, useEffect } from 'react'
import { getBatteryDetailsList, DeleteBatteryData } from './ActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import Nodataimage from '../../../../../images/nodata.png'

const itemsPerPage = 10;
export default function List({ handleTab, handleEditingData }) {
    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [listData, setListData] = useState([])
    const [filteredData, setfilteredData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        getBatteryDetailsListFn()
    }, [])

    const getBatteryDetailsListFn = () => {
        setLoader(true)
        getBatteryDetailsList(callback => {
            console.log("cal", callback)
            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200) {
                setCurrentPage(1)
                setListData(callback?.data)
                filterFunction(callback?.data, 1)
            } else {
                setListData([])
            }
        })
    }

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setfilteredData(currentItems)
    }

    const handleDelete = (data) => {
        setLoader(true)
        DeleteBatteryData(data?.id, callback => {

            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200) {
                setPopup({ show: true, popupStatus: "Data Deleted Successfully" })
                getBatteryDetailsListFn()
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Data" })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleEdit = (data) => {
        handleEditingData(data)
        handleTab("add")
    }


    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        filterFunction(tableData, value)
    };
    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                {
                    filteredData && filteredData?.length > 0 ?
                        <>
                            <div className='phocket-table-new' style={{ borderRadius: '15px', paddingBottom: '2px', marginTop: '20px', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px' }}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Product Code</th>
                                                <th className='text-center'>Brand</th>
                                                <th className='text-center'>Model Name</th>
                                                <th className='text-center'>Capacity(Ah)</th>
                                                <th className='text-center'>voltage(V)</th>
                                                <th className='text-center'>Battery Type </th>
                                                <th className='text-center'>Warrenty (in Month)</th>
                                                <th className='text-center'>Price</th>
                                                <th className='text-center'>Manufacture Date </th>
                                                <th className='text-center'>Expire Date </th>
                                                <th className='text-center'>Added On </th>
                                                <th className='text-center'>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredData?.map((val, id) => {
                                                    return (
                                                        <tr>
                                                            <td className='text-center'>{val?.productCode}</td>
                                                            <td className='text-center'>{val?.brand}</td>
                                                            <td className='text-center'>{val?.modelName}</td>
                                                            <td className='text-center'>{val?.capacityAh}</td>
                                                            <td className='text-center'>{val?.voltageV}</td>
                                                            <td className='text-center'>{val?.batteryType}</td>
                                                            <td className='text-center'>{val?.warrantyMonths}</td>
                                                            <td className='text-center'>{val?.price}</td>



                                                            <td className='text-center'>{moment(val?.manufactureDate).format("DD-MM-YYYY") || ""}</td>
                                                            <td className='text-center'>{moment(val?.expiryDate).format("DD-MM-YYYY") || ""}</td>
                                                            <td className='text-center'>{moment(val?.addedOn).format("DD-MM-YYYY")}</td>
                                                            <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                                <button onClick={() => handleEdit(val)}>
                                                                    <i className='fa fa-edit'></i>
                                                                </button>
                                                                <button onClick={() => handleDelete(val)}>
                                                                    <i className='fa fa-trash-o'></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'end', margin: '10px 0' }}>
                                    <Pagination
                                        count={Math.ceil(listData?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div>
                            </div>
                        </>
                        :
                        <div className='text-center'>
                            <img src={Nodataimage} width={"30%"} />
                        </div>
                }

            </div>
        </>
    )
}
